import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InfluencersTabType, UnionOfKeys } from '@anytag/shared-types';
import { ThreadsInfluencer, SocialAccountType, SocialAccountInfluencerListSortField } from '@anytag/graphql';
import {
  PostType,
  DefaultInfluencersProps,
  InfluencersFilterBaseSchema,
  InfluencersBaseSearchStateSchema
} from '../schemaTypes';

export const ThreadsInfluencersFilterSchema = InfluencersFilterBaseSchema.pick({
  tab: true,
  minAge: true,
  maxAge: true,
  status: true,
  keyword: true,
  genders: true,
  minReach: true,
  maxReach: true,
  regionIds: true,
  provinceIds: true,
  interests: true,
  includeIds: true,
  countryIds: true,
  categoryIds: true,
  audienceAge: true,
  minSaveRate: true,
  maxSaveRate: true,
  keywordField: true,
  minFollowers: true,
  maxFollowers: true,
  minPostPrice: true,
  maxPostPrice: true,
  minStoryPrice: true,
  maxStoryPrice: true,
  audienceRatio: true,
  audienceGender: true,
  minEngagementRate: true,
  maxEngagementRate: true,
  followerGrowthPeriod: true,
  followerGrowthPercentage: true,
  talentAgencyOrPartnerIds: true
});

// Don't put this in utils, it can be loaded after search schema created so the initial data might be wrong
export const defaultThreadsInfluencersFormValues = ThreadsInfluencersFilterSchema.parse({
  tab: InfluencersTabType.THREADS
});

export const ThreadsInfluencersSearchSchema = SearchSchema.create({
  state: InfluencersBaseSearchStateSchema,
  sort: { field: SocialAccountInfluencerListSortField },
  filter: {
    schema: ThreadsInfluencersFilterSchema,
    defaultValues: defaultThreadsInfluencersFormValues
  }
});

export type ThreadsInfluencersSearchSchemaType = z.infer<typeof ThreadsInfluencersSearchSchema>;
export type ThreadsInfluencersFilterFormValues = ThreadsInfluencersSearchSchemaType['filter'];
export type ThreadsInfluencersFilterFormKeys = UnionOfKeys<ThreadsInfluencersFilterFormValues>;
export type ThreadsInfluencersProps = DefaultInfluencersProps<ThreadsInfluencerProfile>;
export type ThreadsInfluencerProfile = { posts: PostType[]; socialAccountType: SocialAccountType } & Pick<
  ThreadsInfluencer,
  | 'id'
  | 'age'
  | 'name'
  | 'gender'
  | 'avatar'
  | 'country'
  | 'averageLikes'
  | 'isBrandAccount'
  | 'socialAccountId'
  | 'socialAccountStatus'
  | 'socialAccountFollowers'
  | 'socialAccountEngagementFollowersRate'
>;
